import { render, staticRenderFns } from "./BookHoterExtPre.vue?vue&type=template&id=678cb12f&scoped=true&"
import script from "./BookHoterExtPre.vue?vue&type=script&lang=js&"
export * from "./BookHoterExtPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cb12f",
  null
  
)

export default component.exports